import {handleActions} from 'redux-actions';
import {LOAD_DEVICES} from './Actions';
import {Device, ListPayload, ListState, LoadDevicesAction} from './Types';

export const initialState: ListState<Device> = {
    rows: [],
    isLoading: true,
};

export const setDevices = (state: ListState<Device>, action: LoadDevicesAction): ListState<Device> => {
    const {rows} = action.payload;
    
    if (rows) {
        return {
            ...state,
            rows,
            isLoading: false,
        };
    }
    
    return {
        ...initialState,
        isLoading: false,
    };
};

const handlers = {
    [LOAD_DEVICES]: setDevices,
};

export default handleActions<ListState<Device>, ListPayload<Device>>(handlers, initialState);
